<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据管理</el-breadcrumb-item>
      <el-breadcrumb-item>CT数据</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card v-loading="loading">
      <el-form ref="FormRef" :model="form" label-width="120px">
        <el-form-item label="文件上传">
          <el-upload
            class="upload-demo"
            action="#"
            :http-request="uploadData"
            :before-upload="checkUploadZip"
            :show-file-list="false"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选择文件</el-button
            >
            <div class="el-upload__tip">上传zip格式数据，不超过600m</div>
          </el-upload>
        </el-form-item>

        <el-form-item
          v-for="row in form.list"
          :key="row.subdir"
        >
          <el-col class="line" :span="1.2">姓名：</el-col>
          <el-col class="line" :span="4">
            <el-input v-model="row.name" style="width: 80%"></el-input>
          </el-col>
          <el-col class="line" :span="1.2">年龄：</el-col>
          <el-col class="line" :span="2">
            <el-input v-model="row.age" style="width: 80%"></el-input>
          </el-col>
          <el-col class="line" :span="1.2">性别：</el-col>
          <el-col class="line" :span="2">
            <el-input v-model="row.gender" style="width: 80%"></el-input>
          </el-col>
          <!-- <el-col class="line" :span="1">部位：</el-col>
          <el-col class="line" :span="4">
            <el-select
              v-model="row.scanpart"
              placeholder="请选择"
              style="width: 80%"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col> -->
          <el-col class="line" :span="1.2">时间：</el-col>
          <el-col class="line" :span="4">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="row.scantime"
			  value-format="yyyy-MM-dd"
              style="width: 80%"
            ></el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item v-show="ifshow">
          <el-button type="primary" @click="onSubmit" size="small"
            >提交</el-button
          >
          <el-button size="small" @click="clear">取消</el-button>
        </el-form-item>
      </el-form>

      <el-dialog
        title="上传"
        :visible.sync="uploadDialogVisible"
        width="25%"
        @close="interuptUpload"
      >
        <div style="text-align: center">
          <el-progress
            type="circle"
            :percentage="uploadDiag.progressPercent"
            style="margin-left: 20px"
          ></el-progress>
          <h5>{{ uploadDiag.text }}</h5>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      ifshow: false,
      uploadDialogVisible: false,
      uploadDiag: {
        progressPercent: 0,
        text: "",
      },
      options: [{ value: "CHEST" }, { value: "HEART" }],
      form: { tempdid: null, list: [] },
    };
  },
  methods: {
    async onSubmit() {
      
      for (var i = 0; i < this.form.list.length; i++) {
        if (this.form.list[i].name === "") {
          this.$message({ message: "未输入姓名", type: "error" });
          return;
        }
      }
      this.loading = true;
      const { data } = await this.$http.post("/submitDataMulti", this.form);
      this.loading = false;
      if (data.status === 100) {
        this.$message({ message: "提交成功", type: "success" });
        this.$router.push("/ctData");
      }
    },
    async uploadData(params) {
      let formdata = new FormData();
      formdata.append("zipfile", params.file);

      this.source = this.$http.CancelToken.source();
      const config = {
        "Content-Type": "multipart/form-data",
        cancelToken: this.source.token,
        onUploadProgress: (progressEvent) => {
          this.uploadDiag.progressPercent = Number(
            ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2)
          );
          if (this.uploadDiag.progressPercent === 100)
            this.uploadDiag.text = "正在解析";
        },
      };
      this.uploadDialogVisible = true;
      this.uploadDiag.progressPercent = 0;
      this.uploadDiag.text = "正在上传";
      const { data } = await this.$http.post(
        "/uploadDicomMulti",
        formdata,
        config
      );
      this.uploadDialogVisible = false;
      if (data.status === 100) {
        this.$message({
          message: "上传成功",
          type: "success",
        });

        let res = data.data;
        // console.log(res)
        this.form.tempid = res.tempid;
        this.form.list = [];
        // console.log(res.list)
        for (var i = 0; i < res.list.length; i++) {
          this.form.list.push({
            name: res.list[i].name,
            gender: res.list[i].gender,
            age: res.list[i].age,
            scantime: res.list[i].scantime,
            // scanpart: res.list[i].scanpart,
            subdir: res.list[i].subdir,
          });
        }
        this.ifshow = true;
      }
    },
    checkUploadZip(file) {
      if (file.name.endsWith(".zip") === false) {
        this.$message({
          message: "请上传zip格式压缩包",
          type: "error",
        });
        return false;
      }
      if (file.size > 600 * 1024 * 1024) {
        this.$message({
          message: "文件大小不超过600m",
          type: "error",
        });
        return false;
      }
    },
    interuptUpload() {
      if (this.uploadDiag.progressPercent < 100) {
        this.source.cancel();
      }
    },
    clear() {
      this.form.tempdid = null;
      this.form.list = [];
      this.ifshow = false;
    },
  },
  created() {},
  computed: {},
};
</script>

<style lang="less" scoped>
</style>
